import CodeMirror from 'codemirror';
import { matchTokenType } from './utils';
import { createSpanReplacementNode } from '../markers/utils';
import { matchFqnPath } from '../../utils/fqn';
import { IModelField } from '../../editor/index.d';


// 属性路径替换
export function replaceFqnProperties(options: {
  editor: CodeMirror.Editor,
  tokens: CodeMirror.Token[],
  idx: number,
  showDescription: boolean,
  fqn: IModelField
}) {
  const { editor, tokens, idx, showDescription, fqn } = options;
  const token = tokens[idx];
  if (matchTokenType(token, 'property')) {
    const line = token.state.line;
    const startPos = { line, ch: token.start };
    const endPos = { line, ch: token.end };

    let tooltip = '';

    if (showDescription) {
      // 获取fqn路径后可计算出该路径的详细信息（包括数据类型和描述信息）
      const fqnPathType = token.type!.split(' ').find(item => item.includes('path::'));
      const fqnPath = fqnPathType ? fqnPathType.slice(6) : '';
      const fqnObject = matchFqnPath(fqn, fqnPath);
      if (fqnObject) {
        const title = fqnObject.title || '';
        const description = fqnObject.description || '';
        tooltip = `
       <h3 style="color:#fff; font-size: 14px;">${title}</h3>
       <div style="color:#fff; font-size: 12px;">${description}</div>
       `;
      }
    }

    editor.getDoc().markText(startPos, endPos, {
      replacedWith: createSpanReplacementNode(token.string, 'cm-property', tooltip)
    });
    return 1;
  }
  return 0;
}
